export const GuildRegistry = {
  _format: 'hh-sol-artifact-1',
  contractName: 'GuildRegistry',
  sourceName: 'contracts/erc20guild/utils/GuildRegistry.sol',
  abi: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'guildAddress',
          type: 'address',
        },
      ],
      name: 'AddGuild',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'guildAddress',
          type: 'address',
        },
      ],
      name: 'RemoveGuild',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'guildAddress',
          type: 'address',
        },
      ],
      name: 'addGuild',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'getGuildsAddresses',
      outputs: [
        {
          internalType: 'address[]',
          name: '',
          type: 'address[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      name: 'guilds',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'index',
      outputs: [
        {
          internalType: 'uint256',
          name: '_value',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'initialize',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'guildAddress',
          type: 'address',
        },
      ],
      name: 'removeGuild',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ] as const,
  bytecode:
    '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',
  deployedBytecode:
    '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',
  linkReferences: {},
  deployedLinkReferences: {},
};
